import idsTokensDefault from '../../utils/tokens/idsTokens';

/**
 * @TODO this hardcoded value should come from a token
 * is Peek component not fully tokenized?
 */
const PEEK_BACKGROUND_COLOR = '#f6f7fb';

export const svgArrow = ({ variant, idsTokens = idsTokensDefault }) => {
  const pointerFillColor =
    variant === 'peek'
      ? PEEK_BACKGROUND_COLOR
      : variant === 'light'
      ? idsTokens.tooltip.inverse.color.background
      : idsTokens.tooltip.default.color.background;

  const pointerStrokeColor =
    variant === 'light' || variant === 'peek'
      ? idsTokens.tooltip.inverse.color.border
      : idsTokens.tooltip.default.color.border;

  const svgString = `<svg width="12" height="10" viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g>
      <path id="pointer-fill" fill="${pointerFillColor}" d="M6 10L12 2V0H0V2L6 10Z" />
      <path id="pointer-stroke" fill="${pointerStrokeColor}" fill-rule="evenodd" clip-rule="evenodd" d="M0 2L6 10L12 2V1H0V2ZM0.5 1L6 8.33333L11.5 1H0.5Z" />
    </g>
  </svg>`;

  const encodedSvg = encodeURIComponent(svgString)
    .replace(/'/g, '%27')
    .replace(/"/g, '%22');
  return 'data:image/svg+xml;charset=utf-8,' + encodedSvg;
};

export const styles = ({ idsTokens = idsTokensDefault }) => {
  /**
   * Styles can also receive params and classes as props if needed
   * e.g:
   * export const styles = ({ idsTokens = idsTokensDefault }, params, classes) => {}
   */
  const baseStyles = {
    title: {
      fontSize: idsTokens.typography.font.size.sm,
      fontWeight: idsTokens.typography.font.weight.regular,
      lineHeight: idsTokens.typography.lineHeight.sm,
      letterSpacing: idsTokens.typography.spacing.letter.md,
      maxWidth: 480,
      textWrap: 'wrap',
    },
    subtitle: {
      textWrap: 'wrap',
      maxWidth: 480,
    },
    tooltip: {
      borderRadius: idsTokens.tooltip.default.radius.radius,
      boxShadow: `0px 8px 20px 0px ${idsTokens.functional.shadow.levelThree.color}`,
      minWidth: idsTokens.tooltip.default.sizing.min,
      minHeight: idsTokens.tooltip.default.sizing.min,
      paddingRight: idsTokens.tooltip.default.spacing.default.padding.side,
      paddingLeft: idsTokens.tooltip.default.spacing.default.padding.side,
      paddingTop: idsTokens.tooltip.default.spacing.default.padding.top,
      paddingBottom: idsTokens.tooltip.default.spacing.default.padding.bottom,
    },
  };

  const tooltipColors = {
    light: {
      ...baseStyles.tooltip,
      background: idsTokens.tooltip.inverse.color.background,
      color: idsTokens.tooltip.inverse.color.text,
      border: `solid 1px ${idsTokens.tooltip.inverse.color.border}`,
      '& .MuiTooltip-arrow': {
        '&:before': {
          background: `url(${svgArrow({ variant: 'light', idsTokens })})`,
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'contain',
        },
      },
    },
    dark: {
      ...baseStyles.tooltip,
      background: idsTokens.tooltip.default.color.background,
      color: idsTokens.tooltip.default.color.text,
      border: `solid 1px ${idsTokens.tooltip.default.color.border}`,
      '& .MuiTooltip-arrow': {
        '&:before': {
          background: `url(${svgArrow({ variant: 'dark', idsTokens })})`,
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'contain',
        },
      },
    },
    peek: {
      backgroundColor: PEEK_BACKGROUND_COLOR,
      maxWidth: 'none',
      '& .MuiTooltip-arrow': {
        '&:before': {
          background: `url(${svgArrow({ variant: 'peek', idsTokens })}) 0 0 no-repeat`,
          transformOrigin: 'center',
        },
      },
    },
  };

  const largeStyles = {
    title: {
      fontSize: idsTokens.typography.font.size.base,
      fontWeight: idsTokens.typography.font.weight.bold,
      lineHeight: idsTokens.typography.lineHeight.base,
      letterSpacing: idsTokens.typography.spacing.letter.lg,
    },
    subtitle: {
      fontSize: idsTokens.typography.font.size.sm,
      fontWeight: idsTokens.typography.font.weight.regular,
      lineHeight: idsTokens.typography.lineHeight.sm,
      letterSpacing: idsTokens.typography.spacing.letter.md,
    },
    labelSpacer: {
      marginTop: idsTokens.tooltip.default.spacing.default.padding.top,
    },
  };

  return {
    peek: tooltipColors.peek,
    'small-light-title': baseStyles.title,
    'small-light-tooltip': tooltipColors.light,
    'small-dark-title': baseStyles.title,
    'small-dark-tooltip': tooltipColors.dark,
    'large-light-title': largeStyles.title,
    'large-light-subtitle': {
      ...largeStyles.subtitle,
      color: idsTokens.tooltip.default.color.title.label.subtitle.secondary,
    },
    'large-light-tooltip': {
      ...tooltipColors.light,
      ...largeStyles.tooltip,
    },
    'large-light-labelSpacer': largeStyles.labelSpacer,
    'large-dark-title': largeStyles.title,
    'large-dark-subtitle': {
      ...largeStyles.subtitle,
      color: idsTokens.tooltip.default.color.title.label.subtitle.primary,
    },
    'large-dark-tooltip': {
      ...tooltipColors.dark,
      ...largeStyles.tooltip,
    },
    'large-dark-labelSpacer': largeStyles.labelSpacer,
  };
};
